<template>
  <div class="herbal-medicine-index">
    <div class="contain">
      <!-- 上方按钮 -->
      <el-row class="button-group">
      </el-row>
      <el-row
        class="pinyin-btn-group row-bg"
        type="flex"
        justify="space-between">
        <el-button
          size="mini"
          icon="el-icon-search"
          @click="searchB()"
          class="more-search-css"
        ></el-button>
        <el-input
          size="mini"
          placeholder="请输入关键字搜索"
          v-model="rectificationName"
          class="search-input"
          v-show="showS"
          @input="keyWords(rectificationName)"
        ></el-input>
        <el-button size="small" :class="all ? 'select-checked' : 'no-checked'" @click="resetZM()">按年代检索</el-button>
        <el-button
          :class="item.checked ? 'ZM-selected' : 'ZM'"
          v-for="(item, index) in zimuList"
          :key="index"
          @click="select(item, index, 6)"
        >{{ item.name }}</el-button
        >
      </el-row>
      <el-row class="tag-row my-tag zcy">
        已选择：
        <el-tag
          v-for="(item, index) in selectLabel"
          :key="index"
          :type="item.name"
          closable
          @close="handleClose(item.name)"
        >{{ item.name }}</el-tag
        >
      </el-row>
      <el-row :gutter="20" class="video-list">
        <el-col :span="6" v-for="(item, index) in zhongcaoyaoList" :key="index" class="col">
          <div @click="zhongcaoyaoD(item.id)" class="shou">
            <el-card>
              <img src="../assets/img/gf.png" class="image">
              <div style="padding: 10px;">
                <span class="hide">{{ item.rectificationName }}</span>
                <div class="bottom clearfix">
                  <time class="time">{{ item.source }}</time>
                </div>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-pagination
            background
            layout="prev, pager, next"
            :total="pageInfo.total"
            :page-size="pageInfo.pageSize"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: "HerbalMedicineIndex",
  data() {
    return {
      showS: false, //搜索框不显示
      // 全部与那五个的筛选条件是否选中开始
      all: true,
      one: false,
      two: false,
      three: false,
      four: false,
      five: false,
      // 全部与那五个的筛选条件是否选中结束
      // 五个筛选条件的弹框默认是否显示开始
      visible1: false,
      visible2: false,
      visible3: false,
      visible4: false,
      visible5: false,
      // 五个筛选条件的弹框默认是否显示结束
      zimuList: [],
      // 7个选中的搜索条件开始
      rectificationName: "",
      searchInput: "", //文本框搜索内容
      ypgx: "",
      yw: "",
      yx: "",
      gj: "",
      yybw: "",
      selectZM: "",
      selectName: '',
      // 7个选中的搜索条件结束
      zhongcaoyaoList: [], //中草药列表数据
      // dynamicTags: ["标签一", "标签二", "标签三"],
      selectLabel: [] //已选择的条件
    };
  },
  methods: {
    //删除已选的某个标签
    handleClose(tag) {
      let that = this;
      // console.log(tag);
      that.selectLabel.splice(that.selectLabel.indexOf(tag), 1);
      that.effectList.findIndex(item => {
        if (item.name === tag) {
          item.checked = false;
          that.one = false;
          that.ypgx = "";
          that.effectList[0].checked = true;
        }
      });
      that.yaoxingList.findIndex(item => {
        if (item.name === tag) {
          item.checked = false;
          that.two = false;
          that.yx = "";

          that.yaoxingList[0].checked = true;
        }
      });
      that.yaoweiList.findIndex(item => {
        if (item.name === tag) {
          item.checked = false;
          that.three = false;
          that.yw = "";

          that.yaoweiList[0].checked = true;
        }
      });

      that.guijingList.findIndex(item => {
        if (item.name === tag) {
          item.checked = false;
          that.four = false;
          that.gj = "";

          that.guijingList[0].checked = true;
        }
      });

      that.yaobuweiList.findIndex(item => {
        if (item.name === tag) {
          item.checked = false;
          that.five = false;
          that.ypbw = "";

          that.yaobuweiList[0].checked = true;
        }
      });
      that.zimuList.findIndex(item => {
        if (item.name === tag) {
          item.checked = false;
          that.six = false;
          that.selectZM = "";
        }
      });

      that.getList(
        that.rectificationName,
        that.searchInput,
        that.ypgx,
        that.yx,
        that.yw,
        that.gj,
        that.yybw,
        that.selectZM
      );
    },
    //中草药详情
    zhongcaoyaoD(id) {
      this.$router.push({
        path: "/ancPreDetail",
        query: { id: id }
      });
    },
    //选页
    handleCurrentChange(v) {
      let that = this;
      that.pageInfo.pageNum = v; //当前页
      that.getList(
        that.rectificationName,
        that.selectZM,
        that.pageInfo.pageNum
      );
    },
    //搜索按钮
    searchB() {
      let that = this;
      if (that.showS) {
        that.showS = false;
      } else {
        that.showS = true;
      }
    },
    //全部
    allData() {
      let that = this;
      that.searchInput = that.ypgx = that.yx = that.yw = that.gj = that.yybw =
        "";
      that.selectLabel = [];
      that.all = true;
      that.one = that.two = that.three = that.four = that.five = false;
      for (let c of that.effectList) {
        c.checked = false;
      }
      that.effectList[0].checked = true;
      for (let c of that.yaoxingList) {
        c.checked = false;
      }
      that.yaoxingList[0].checked = true;
      for (let c of that.yaoweiList) {
        c.checked = false;
      }
      that.yaoweiList[0].checked = true;
      for (let c of that.guijingList) {
        c.checked = false;
      }
      that.guijingList[0].checked = true;
      for (let c of that.yaobuweiList) {
        c.checked = false;
      }
      that.yaobuweiList[0].checked = true;
      for (let c of that.zimuList) {
        c.checked = false;
      }
      that.getList();
    },
    // 年代搜索
    yearsSearch() {
      let that = this;
      // let url = "/years/list";
      let url = "/years/parent/getYearsList";
      let parmas = {}
      that.$http
        .post(url, parmas)
        .then(res => {
          this.zimuList = res.data.data
        })
    },
    //searchInput搜索框
    getList(selectZM,rectificationName, pageNum) {
      let that = this;
      if (pageNum) {
        that.pageInfo.pageNum = pageNum;
      } else {
        that.pageInfo.pageNum = 1;
      }
      let url = "/ancientPrescription/pageAncientPrescriptionMoreYears";
      let parmas = {
        years: rectificationName,
        rectificationName:selectZM,
        pageNum: that.pageInfo.pageNum,
        pageSize: that.pageInfo.pageSize
      };
      axios.post(url, parmas)
        .then(res => {
          if (res.data.code == 200) {
            that.pageInfo.total = res.data.data.total;
            that.pageInfo.pageSize = res.data.data.pageSize;
            that.zhongcaoyaoList = res.data.data.list
          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          that.$message.error("网络错误！");
        });
    },
    //searchInput搜索框
    keyWords(rectificationName) {
      let that = this;
      let data = ''
      that.getList(rectificationName, data);
    },
    //已选择的标签
    selectLableFunction() {
      let that = this;
      that.selectLabel = [];
      if (that.selectZM) {
        that.selectLabel.push({
          name: that.selectName
        });
      }
    },
    select(v, i, n) {
      let that = this;
      //字母
      for (let c of that.zimuList) {
        c.checked = false;
      }
      v.checked = true;
      that.all = false;
      that.selectZM = v.id;
      that.selectName = v.name;
      that.selectLableFunction();
      let data = ''
      that.getList(
        data, that.selectZM
      );
    },
    //重置字母
    resetZM() {
      let that = this;
      for (let c of that.zimuList) {
        c.checked = false;
      }
      that.selectZM = "";
      that.selectLableFunction();
      that.getList(
        that.rectificationName,
        that.searchInput,
        that.ypgx,
        that.yx,
        that.yw,
        that.gj,
        that.yybw,
        that.selectZM
      );
    }
  },
  created() {
    let that = this;
    that.getList();
    that.yearsSearch()
    // that.dataDictionary("medicine");
    // that.dataDictionary("pill");
    // that.dataDictionary("channelTropism");
    // that.dataDictionary("medicinalPart");
    // that.dataDictionary("efficacyDrugsDescribe");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/deep/ .el-tag {
  margin: 0;
}
/deep/ .el-card__body {
  padding: 0;
  /*padding-bottom: 30px;*/
}
.col {
  margin-bottom: 20px;
}
.hide{
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  display: inline-block;
  width: 203px;
}
.el-carousel img {
  width: 100%;
  /* height: 100%; */
}
.el-carousel--horizontal {
  width: 100%;
  height: 100%;
}
/deep/.el-card__body{
  padding: 0px;
}
.img-outer {
  width: 241px;
  height: 136.13px;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.tag-row {
  text-align: left;
  margin: 20px auto;
  padding-left: 15px;
  color: #666666;
}

.button-group .el-button {
  padding: 9px 20px;
}


.button-group {
  text-align: center;
  padding: 0px 0px 30px;
}

.el-button--small,
.el-button--small.is-round {
  padding: 9px 20px;
}
/* .video-list {
  width: 75%;
} */
.video-list img {
  width: 100%;
  height: 100%;
}
.forum-title {
  font-size: 16px;
  line-height: 50px;
  color: #333333;
}
/* 字母没选中 */
.ZM {
  background-color: #f8f8f8;
  margin-bottom: 10px;
  padding: 6px;
}
/* 字母选中 */
.ZM-selected {
  background-color: #fff4f2;
  border: solid 1px #f64420;
  color: #f64420;
  margin-bottom: 10px;
  padding: 6px;
}
/* 字母悬停 */
.ZM:hover {
  color: white;
  border: 1px solid #f64420;
  background-color: #f64420;
}
.el-row--flex.is-justify-space-between {
  flex-wrap: wrap;
  justify-content: normal;
}
.zcy {
  padding-left: 0px;
}
.box-card {
  display: flex;
}
</style>
<style>
.top-carousel-medicine .el-carousel__indicators--horizontal {
  bottom: 10px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 100%;
  text-align: center;
}
/* .top-carousel-box .el-carousel__container {
  position: relative;
  height: 300px;
} */
.top-carousel.top-carousel-medicine .el-carousel__container {
  height: 100% !important;
}
.el-button--mini, .el-button--mini.is-round {
  padding: 0;
}
.el-button {
  padding: 5px 20px;
  height: 30px;
  margin-right: 10px;
  margin-left: 0px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/ancPre.vue